export const getNewCameraConfig = ({ viewer, cameraConfig }) => {
    const target = viewer.getCameraTargetArray()
    const position = viewer.getCameraPositionArray()
    const pivot = viewer.getCameraPivotArray()
    const up = viewer.getCameraUpArray()
    const zoom = viewer.getCameraZoom()
    const newCameraConfig = {
        ...cameraConfig,
        position,
        up,
        target,
        pivot,
        zoom,
    }

    return newCameraConfig
}
